import { StrictMode, startTransition } from 'react'
import type { ComponentProps } from 'react'

import * as Sentry from '@sentry/react-router'
import { hydrateRoot } from 'react-dom/client'
import { isRouteErrorResponse } from 'react-router'
import { HydratedRouter } from 'react-router/dom'

Sentry.init({
  dsn: window.ENV.SENTRY_DSN,
  integrations: [Sentry.reactRouterTracingIntegration()],
  release: window.ENV.RELEASE,
  tracesSampleRate: 0.0
})

const handleReactError = Sentry.reactErrorHandler()

const handleRouterError: NonNullable<ComponentProps<typeof HydratedRouter>['onError']> = (error, { errorInfo }) => {
  if (isRouteErrorResponse(error) && error.status === 404) {
    return
  }

  if (errorInfo) {
    handleReactError(error, errorInfo)
  } else {
    Sentry.captureException(error, {
      mechanism: {
        type: 'react-router',
        handled: false
      }
    })
  }
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter onError={handleRouterError} />
    </StrictMode>
  )
})
